module.exports = __webpack_public_path__ + "prod/1.42.2/img/lvcheng-icon.46f91a6f.png";